import React from 'react'

export default function NotFound() {
    return (
        <div className="NotFound">
            404 NotFound
        </div>
    )
}
